// src/TeamChart.js
import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const TeamChart = ({ team }) => {
  // Guard clause in case team data is still loading asynchronously
  if (!team) return <p>Loading chart...</p>;

  // Use team.price_history to match the database column/seeded property name
  const data = team.price_history || team.priceHistory || [];

  return (
    <div style={{ marginTop: "2rem" }}>
      <h3>{team.name} Price History</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data} margin={{ top: 20, right: 20, left: 0, bottom: 5 }}>
          <XAxis dataKey="date" />
          <YAxis domain={["auto", "auto"]} />
          <Tooltip />
          <Line type="monotone" dataKey="price" stroke="#8884d8" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TeamChart;